// 接口文件去统一管理api
import {
  get,
  post
} from '@/utils/request'

// export const query = (params) => get('/pur/pay/pageInit', params)

export default {
  loginByAccountAndPass(data) { //账号密码登录
    return post('/wfboot_user/api/webapi/login/loginByAccountAndPass', data)
  }, //课程分类列表
  categoryList(data) {
    return post('wfboot_peix/api/webapi/course/categoryList', data)
  },
  courseList(data) { //课程列表
    return post('wfboot_peix/api/webapi/course/courseList', data)
  },
  getCourse(data) { //课程详情
    return post('wfboot_peix/api/webapi/course/getCourse', data)
  },
  loadCatalogs(data) { //课程内容
    return post('wfboot_peix/api/webapi/course/loadCatalogs', data)
  },
  getService(data) { //获取客服
    return post('wfboot_taskmsg/api/webapi/message/getService', data)
  },
  queryGoods() { //首页列表
    return post('wfboot_peix/api/webapi/course/classifyListList')
  }, //关于我们和帮助中心
  getAssistList(data) {
    return post('/wfboot_article/api/webapi/article/getAssistList', data);
  }, //观看完某个章节
  recordChapter(data) {
    return post('wfboot_peix/api/webapi/course/recordChapter', data);
  },//记录观看
  record(data){
    return post('/wfboot_user/api/webapi/course/record', data);
  }, //最近5个播放历史
  historyList(data) {
    return post('wfboot_peix/api/webapi/course/historyList', data);
  },//立即观看
  watchCourse(data){
    return post('/wfboot_user/api/webapi/course/watchCourse', data);
  }, //收藏
  collect(data) {
    return post('wfboot_peix/api/webapi/course/collect', data);
  }, //数据统计
  attention(data) {
    return post('wfboot_peix/api/webapi/course/attention', data)
  },
  getNumberCountData(data) {
    return post('wfboot_peix/api/webapi/course/getNumberCountData', data)
  }, //消息列表
  messageList(data) {
    return post('/wfboot_order/api/webapi/message/messageList', data);
  }, //用户详情
  getUserInfoData(data) {
    return post('/wfboot_user/api/webapi/user/getUserInfoData', data);
  },//修改用户信息
  modifyUserInfo(data){
    return post('/wfboot_user/api/webapi/user/modifyUserInfo', data);
  }, //修改密码
  modifyPassword(data) {
    return post('/wfboot_user/api/webapi/user/modifyPassword', data);
  },
  hasCollect(data) { //是否有收藏
    return post('wfboot_peix/api/webapi/course/hasCollect', data);
  },
  publish(data) { //提交评论
    return post('wfboot_peix/api/webapi/course/comment', data);
  },
  comments(data) { //获取评论
    return post('wfboot_peix/api/webapi/course/comments', data);
  },
  collectList(data) { //我的-收藏
    return post('wfboot_peix/api/webapi/course/collectList',data);
  }, //首页轮播图
  getAdvertisings(data) {
    return post('/wfboot_article/api/webapi/article/getAdvertisings', data);
  }, //资讯分类
  loadChannels(data) {
    return post('/wfboot_article/api/webapi/article/loadChannels', data);
  }, //资讯列表
  articleList(data) {
    return post('/wfboot_article/api/webapi/article/ArticleList', data);
  },
  getArticleContent(data) {
    return post('/wfboot_article/api/webapi/article/getArticleContent', data);
  },//首页我的必修课展示
  myclassifyList() {
    return post('wfboot_peix/api/webapi/course/myclassifyList');
  },//数据统计-个人
  statistical(data){
    return post('wfboot_peix/api/webapi/course/statistical',data);
  },//数据统计-个人-选修
  statisticalOptional(data){
    return post('wfboot_peix/api/webapi/course/statisticalOptional',data);
  },//课程推荐
  recommendList(data){
    return post('/wfboot_user/api/webapi/course/recommendList',data);
  },//文件上传
  getUpSign(data){
    return post('/wfboot_assets/api/fs/file/getUpSign',data);
  },//搜索
  search(data){
  return post('/wfboot_user/api/webapi/course/search',data);
  },//导出
  toExecl(data){
    return post('wfboot_peix/api/webapi/course/toExecl',data);
  },//获取消息数
  getNotReadMsgNum(data){
    return post('/wfboot_assets/api/webapi/message/getNotReadMsgNum',data);
  },//一键已读
  oneKeyRead(data){
    return post('/wfboot_assets/api/webapi/message/oneKeyRead',data);
  }
}



// WEBPACK FOOTER //
// ./src/utils/apis.js